function parseInputDate(input) {
  const value = (input.value || '').trim();
  if (value === '') {
    return null;
  }

  if (input.type === 'date') {
    const parts = value.split('-');
    if (parts.length !== 3) {
      return null;
    }

    const year = Number(parts[0]);
    const month = Number(parts[1]);
    const day = Number(parts[2]);
    if (!year || !month || !day) {
      return null;
    }

    const date = new Date(year, month - 1, day);
    if (
      date.getFullYear() !== year
      || date.getMonth() !== month - 1
      || date.getDate() !== day
    ) {
      return null;
    }

    return date;
  }

  const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    const year = Number(isoMatch[1]);
    const month = Number(isoMatch[2]);
    const day = Number(isoMatch[3]);
    const date = new Date(year, month - 1, day);
    if (
      date.getFullYear() === year
      && date.getMonth() === month - 1
      && date.getDate() === day
    ) {
      return date;
    }
  }

  return null;
}

function ensureDisplay(container) {
  let display = container.querySelector('.form__date-display');
  if (display) {
    return display;
  }

  display = document.createElement('span');
  display.className = 'form__date-display';
  display.setAttribute('role', 'button');
  display.setAttribute('tabindex', '0');
  display.setAttribute('aria-label', 'Edit date');

  const wrap = container.querySelector('.wpcf7-form-control-wrap');
  if (wrap) {
    wrap.insertAdjacentElement('beforebegin', display);
  } else {
    container.appendChild(display);
  }

  return display;
}

function syncDateBlock(container) {
  if (!container) {
    return;
  }

  const input = container.querySelector('.form__date-input');
  if (!input) {
    return;
  }

  const display = ensureDisplay(container);
  const date = parseInputDate(input);

  if (!date) {
    display.textContent = '';
    display.hidden = true;
    container.classList.remove('form__date--editing');
    return;
  }

  display.textContent = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  display.hidden = false;
}

function setEditing(container, isEditing) {
  if (!container) {
    return;
  }

  container.classList.toggle('form__date--editing', isEditing);
}

function bindDateBlock(container) {
  const input = container.querySelector('.form__date-input');
  if (!input || input.dataset.formDateDisplayBound === '1') {
    syncDateBlock(container);
    return;
  }

  const handler = () => syncDateBlock(container);
  input.addEventListener('change', handler);
  input.addEventListener('input', handler);
  input.addEventListener('blur', () => {
    setEditing(container, false);
    syncDateBlock(container);
  });
  input.dataset.formDateDisplayBound = '1';

  const display = ensureDisplay(container);
  const openEditor = () => {
    if (!container.classList.contains('form__date--filled')) {
      return;
    }

    setEditing(container, true);
    requestAnimationFrame(() => {
      input.focus();
      input.select?.();
      input.showPicker?.();
    });
  };

  display.addEventListener('click', openEditor);
  display.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    openEditor();
  });

  syncDateBlock(container);
}

function initDateDisplay(root = document) {
  root.querySelectorAll('.form__date').forEach(bindDateBlock);
}

export default {
  init: initDateDisplay,
};
